import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { deleteInvitedMember, getInvitedMemberList } from '../../../data/store/overviewSlice'
import { useParams } from 'react-router-dom'
import CenteredPaperModal from '../CenteredPaperModal'
import EditMemberInvite from '../EditMemberInvite'
import { Typography, Tag, Space, Button, Table, Tooltip, Spin, Row, Col, notification } from 'antd';
import Notify, { notify } from '../Notify'

const ShowInvitedUsers = () => {
    const dispatch = useDispatch();
    const { tenantId } = useParams();
    const memberInvitationData = useSelector(state => state.overviewDetails.memberInvitations)
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });
    const [defaultEditData, setDefaultEditData] = useState({})
    const [deleteLoading, setDeleteLoading] = useState({});
    const [openModal, setOpenModal] = useState(false);
    const columns = [
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            align: "center",
            width: 300,
        },
        {
            title: "Role",
            dataIndex: "role",
            key: "role",
            align: "center",
            render: (role) => (
                <Typography.Text>
                    {role === "tenantManager" ? "Bot Manager" : role === "owner" ? "Owner" : ""}
                </Typography.Text>
            ),
        },
        {
            title: "Live Agent",
            dataIndex: "isLiveAgent",
            key: "isLiveAgent",
            align: "center",
            render: (isLiveAgent) =>
                isLiveAgent ? (
                    <Tag color="blue">Live Agent</Tag>
                ) : (
                    <Tag>Not Live Agent</Tag>
                ),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            width: 250,
            render: (status) => {
                let icon = <i className='ri-time-line' />;
                let color = 'warning';
                let label = 'Pending';

                if (status === 'accepted') {
                    icon = <i className='ri-checkbox-circle-line' />;
                    color = 'success';
                    label = 'Accepted';
                } else if (status === 'declined') {
                    icon = <i className='ri-close-circle-line' />;
                    color = 'error';
                    label = 'Expired/Declined';
                }

                return (
                    <Tag
                        icon={icon}
                        color={color}
                    >
                        {label}
                    </Tag>
                );
            },
        },
        {
            title: "Actions",
            key: "actions",
            align: "center",
            width: 150,
            render: (_, record) => (
                <Space>
                    <Tooltip title="Edit">
                        <Button
                            type="text"
                            icon={<i className="ri-pencil-line" />}
                            disabled={record.role === "owner"}
                            onClick={() => {
                                setOpenModal(true);
                                setDefaultEditData({ ...record });
                            }}
                        />
                    </Tooltip>
                    <Tooltip title="Delete">
                        <Button
                            type="text"
                            danger
                            icon={
                                deleteLoading?.[record?._id] ? (
                                    <Spin size="small" />
                                ) : (
                                    <i className="ri-delete-bin-7-line" />
                                )
                            }
                            disabled={record.role === "owner"}
                            onClick={() => handleInvitedMemberDelete(record._id, tenantId)}
                        />
                    </Tooltip>
                </Space>
            ),
        },
    ];

    const tableData = memberInvitationData?.invitations?.map((item) => ({
        key: item._id,
        _id: item._id,
        email: item.email,
        role: item.role,
        isLiveAgent: item.isLiveAgent,
        status: item.status,
    }));


    const fetchInvitedMemberList = () => {
        dispatch(getInvitedMemberList({ tenantId, page: paginationModel.page + 1, limit: paginationModel.pageSize }))
    }

    const handleInvitedMemberDelete = (id, tenantId) => {
        setDeleteLoading((prev) => ({
            ...prev,
            [id]: true,
        }));
        dispatch(deleteInvitedMember({ id, tenantId }))
            .unwrap()
            .finally(() => {
                notify.success({ message: "Invite deleted successfully" })
                fetchInvitedMemberList();
                setDeleteLoading((prev) => ({
                    ...prev,
                    [id]: false,
                }));
            });
    }

    useEffect(() => {
        fetchInvitedMemberList();
    }, [paginationModel])

    return (<>
        <Notify />
        <CenteredPaperModal open={openModal} onClose={() => {
            setOpenModal(false);
        }}>
            <Typography.Text label={5} style={{ fontSize: "17px", marginBottom: 10 }} gutterBottom>Edit Invite</Typography.Text>
            <EditMemberInvite defaultData={defaultEditData} onComplete={() => {
                setOpenModal(false);
                fetchInvitedMemberList();
            }} />
        </CenteredPaperModal>

        <Row justify="space-between" align="middle" style={{ marginBottom: 10 }}>
            <Col>
                <Typography.Title style={{ margin: 0 }} level={4}>Invitations</Typography.Title>
            </Col>
            <Col>
                <Button icon={<i className='ri-refresh-line' />} onClick={fetchInvitedMemberList}>
                    Refresh
                </Button>
            </Col>
        </Row>
        <Table
            columns={columns}
            dataSource={tableData}
            pagination={{
                total: memberInvitationData?.totalCount || 0,
                current: paginationModel.page || 1,
                pageSize: paginationModel.pageSize || 10,
                showSizeChanger: true,
                pageSizeOptions: [5, 10],
                onChange: (page, pageSize) => setPaginationModel({ page, pageSize }),
            }}
        />

    </>
    )
}

export default ShowInvitedUsers